import { render, staticRenderFns } from "./amz_skumgt.vue?vue&type=template&id=52a163e5&scoped=true&"
import script from "./amz_skumgt.vue?vue&type=script&lang=js&"
export * from "./amz_skumgt.vue?vue&type=script&lang=js&"
import style0 from "./amz_skumgt.vue?vue&type=style&index=0&id=52a163e5&scoped=true&lang=css&"
import style1 from "./amz_skumgt.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a163e5",
  null
  
)

export default component.exports